import React, { useState, useEffect, useContext } from "react";
import { Box } from "@mui/system";
import Sidebar from "./sidebar";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Divider,
} from "@mui/material";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import "../App.css";

import { addDoc, collection, query, getDocs } from "firebase/firestore";
import { db, storage } from "../firebase.js";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
//import FormControl from '@mui/material/FormControl';
import FormLabel from "@mui/material/FormLabel";
import { uploadBytes, ref, getDownloadURL } from "firebase/storage";

import DeleteIcon from "@mui/icons-material/Delete";

import { DropzoneAreaBase } from "material-ui-dropzone";

import DataContext from "../context/context";
import getDropDownData from "./hook/getDropDownData";

const steps = [
  "General Information",
  "Housing Journey",
  "Other Agencies",
  "Moses Journey",
  "Rehab Journey",
  "Offending History",
  "Correspondence",
  "Files",
];

let trainingType = [
  "Experiencing Homelessness",
  "Hostel/Shared Accommodation",
  "Sofa Surfing",
  "Living with Friends",
  "Living with Family",
  "Private Rent",
  "Council House",
  "Own House",
];

let rehab = ["Rehab 1", "Rehab 2", "Rehab 3"];

trainingType = trainingType.sort((a, b) => a.localeCompare(b));

export default function AddNew() {
  const [rows, setRows] = useState([]);
  const [dropDownData, setdropDownData] = useState();

  let dropdata = useContext(DataContext);

  let arr = [];

  useEffect(() => {
    test();

    async function test() {
      arr = [];
      getDataName();
    }

    setRows(arr);
    setdropDownData(dropdata);
    if (!dropdata) {
      getRewindData()
    }
  }, []);

  let getRewindData = async ()=>{
    let a = await getDropDownData();
      console.log(a)
      setdropDownData(a);
  }

  const [firstName, setfirstName] = useState("");
  const [surName, setsurName] = useState("");
  const [nationalInsurance, setNationalInsurance] = useState("");
  const [email, setemail] = useState("");
  const [address1, setaddress1] = useState("");
  const [child, setchild] = useState("");
  const [childloc, setchildloc] = useState("");

  const [address2, setaddress2] = useState("");
  const [contact, setcontact] = useState("");
  const [DOB, setDOB] = useState("");
  const [postCode, setpostCode] = useState("");
  const [homeless, sethomeless] = useState("");
  const [town, settown] = useState("");
  const [nationalIns, setnationalIns] = useState("");
  const [nextOfKinName, setnextOfKinName] = useState("");
  const [nextOfKinNumber, setnextOfKinNumber] = useState("");
  const [nextOfKineRelationship, setnextOfKineRelationship] = useState("");
  const [url, seturl] = useState([]);

  const [concDate, setconcDate] = useState("");
  const [concType, setconcType] = useState("");
  const [concLog, setconcLog] = useState("");
  const [concComment, setconcComment] = useState("");
  const [conc, setconc] = useState([]);

  const [startDate, setstartDate] = useState("");
  const [expectedDate, setexpectedDate] = useState("");
  const [actualEndDate, setactualEndDate] = useState("");

  const [prison, setprison] = useState("");
  const [howMany, sethowMany] = useState("");
  const [totlaMonthsServed, settotlaMonthsServed] = useState("");
  const [probation, setProbation] = useState("");
  const [probationOfficer, setProbationOfficer] = useState("");
  const [sexOffender, setSexOffender] = useState("");
  const [numberOfOffences, setNumberOfOffences] = useState("");

  const [statusc, setstatusc] = useState("");

  const [buddy, setbuddy] = useState("");

  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});

  const [RehabDrugs, setRehabDrugs] = useState({
    Alchohol: "",
    Cannabis: "",
    Ecstasy: "",
    Cigrates: "",
    Cocaine: "",
    Heroine: "",
    Amphetamines: "",
    Other: "",
  });

  const [LifeStyle, setLifeStyle] = useState({
    Alchohol: "",
    Behaviour: "",
    Depression: "",
    Drug: "",
    Eating: "",
    Mental: "",
    Debt: "",
    Self: "",
    Physical: "",
    Unemployment: "",
    Confidence: "",
    Violent: "",
  });

  const [Agencies, setAgencies] = useState({
    AdultCare: {
      Name: "Adult Care Service",
      Consent: "",
      Contactname: "",
    },
    MentalHealth: {
      Name: "Mental Health",
      Consent: "",
      Contactname: "",
    },
    CGL: {
      Name: "CGL",
      Consent: "",
      Contactname: "",
    },
    Housing: {
      Name: "Housing Option",
      Consent: "",
      Contactname: "",
    },
    SocialServices: {
      Name: "Social Services",
      Consent: "",
      Contactname: "",
    },
    Probation: {
      Name: "Probation",
      Consent: "",
      Contactname: "",
    },
    FoodBank: {
      Name: "Food Bank",
      Consent: "",
      Contactname: "",
    },
    GP: {
      Name: "GP",
      Consent: "",
      Contactname: "",
    },
    Blank1: {
      Name: "",
      Consent: "",
      Contactname: "",
    },
    Blank2: {
      Name: "",
      Consent: "",
      Contactname: "",
    },
  });

  const pushData = async () => {
    console.log(inputList);
    let main = {
      id: Date.now(),
      firstName,
      surName,
      nationalInsurance,
      email,
      address1,
      address2,
      contact,
      DOB,
      postCode,
      homeless,
      town,
      nationalIns,
      nextOfKinName,
      nextOfKinNumber,
      nextOfKineRelationship,
      files: url,
      child,
      childloc,
      conc,
      startDate,
      expectedDate,
      actualEndDate,

      prison,
      howMany,
      totlaMonthsServed,
      probation,
      probationOfficer,
      sexOffender,
      numberOfOffences,
      buddy,

      statusc,

      RehabDrugs,
      LifeStyle,
      Agencies,

      house: inputList,
      rehab: inputList1,
      convication: inputList2,
    };
    console.log(main);
    await addDoc(collection(db, "employee"), main);
    handleComplete();
  };

  const resetState = () => {
    setLifeStyle();
    setfirstName();
    setsurName();
    setNationalInsurance();
    setemail();
    setaddress1();
    setaddress2();
    setcontact();
    setDOB();
    setpostCode();
    sethomeless();
    settown();
    setnationalIns();
    setnextOfKinName();
    setnextOfKinNumber();
    setnextOfKineRelationship();
    seturl();
    setchild();
    setchildloc();

    setconc([]);
    setconcComment();
    setconcDate();
    setconcLog();
    setconcType();
    setAgencies();

    setstartDate();
    setexpectedDate();
    setactualEndDate();

    setprison();
    sethowMany();
    settotlaMonthsServed();
    setProbation();
    setProbationOfficer();
    setSexOffender();
    setNumberOfOffences();

    setstatusc();

    setbuddy();

    setInputList([{ status: "", date: "" }]);

    setRehabDrugs({
      Alchohol: "",
      Cannabis: "",
      Ecstasy: "",
      Cigrates: "",
      Vaping: "",
      Cocaine: "",
      Heroine: "",
      Amphetamines: "",
      Other: "",
    });
  };

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleCompleteSPC = () => {
    let obj = {
      concDate,
      concType,
      concLog,
      concComment,
      id: Date.now() * Math.random(),
    };
    if (concDate != "") {
      setconc((oldArray) => [...oldArray, obj]);
    }

    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
    resetState();
  };

  const [inputList, setInputList] = React.useState([{ status: "", date: "" }]);
  const [inputList1, setInputList1] = React.useState([
    { status: "", date: "", location: "", value: "" },
  ]);
  const [inputList2, setInputList2] = React.useState([
    { date: "", type: "", details: "" },
  ]);

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };
  const handleInputChange1 = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList1];
    list[index][name] = value;
    setInputList1(list);
  };
  const handleInputChange2 = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList2];
    list[index][name] = value;
    setInputList2(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const handleRemoveClick1 = (index) => {
    const list = [...inputList1];
    list.splice(index, 1);
    setInputList1(list);
  };
  const handleRemoveClick2 = (index) => {
    const list = [...inputList2];
    list.splice(index, 1);
    setInputList2(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { training: "", date: "" }]);
  };
  const handleAddClick1 = () => {
    setInputList1([...inputList1, { qualification: "", date: "" }]);
  };
  const handleAddClick2 = () => {
    setInputList2([...inputList2, { type: "", date: "" }]);
  };
  let urlArr = [];

  async function getDataName() {
    let arr = [];
    const q = query(collection(db, "staff"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, { doc: doc.id });
      console.log(obj);
      arr.push(obj);
    });

    setRows(arr);
  }

  //FOR COLOR DROP DOWN

  const [colorDropDown, setcolorDropDown] = useState({});

  function checkColor(status) {
    if (status == "GREEN") {
      setcolorDropDown({ backgroundColor: "green", color: "white" });
    } else if (status == "ORANGE") {
      setcolorDropDown({ backgroundColor: "orange", color: "white" });
    } else if (status == "RED") {
      setcolorDropDown({ backgroundColor: "red", color: "white" });
    } else {
      setcolorDropDown({ color: "black" });
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "50px",
        height: "100vh",
      }}
    >
      <Sidebar />
      <Box sx={{ width: "60%" }}>
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          sx={{
            "& .Mui-active": {
              color: "#F21D2F",
            },
          }}
        >
          {steps.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepButton color="inherit" onClick={handleStep(index)}>
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div>
          {allStepsCompleted() ? (
            <React.Fragment>
              <div className="LoginPage2">
                <Typography sx={{ mt: 2, mb: 1 }}>
                  Beneficiary Added Successfully
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset} style={{ color: "#F21D2F" }}>
                    Add New
                  </Button>
                </Box>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {/* ADDING FORM */}

              {activeStep == 0 ? (
                <div className="LoginPage">
                  <TextField
                    className="addform"
                    id="outlined-basic"
                    label="First Name"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setfirstName(e.target.value)}
                    value={firstName}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Surname"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setsurName(e.target.value)}
                    value={surName}
                  />
                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-label">
                      Status{" "}
                    </InputLabel>
                    <Select
                      value={statusc}
                      onChange={(e) => {
                        setstatusc(e.target.value);
                        checkColor(e.target.value);
                      }}
                      style={colorDropDown}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Location"
                    >
                      <MenuItem
                        value={"GREEN"}
                        style={{ backgroundColor: "green", color: "white" }}
                      >
                        ㅤ
                      </MenuItem>
                      <MenuItem
                        value={"ORANGE"}
                        style={{ backgroundColor: "Orange", color: "white" }}
                      >
                        ㅤ
                      </MenuItem>
                      <MenuItem
                        value={"RED"}
                        style={{ backgroundColor: "red", color: "white" }}
                      >
                        ㅤ
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    type="date"
                    label="Date of Birth"
                    InputLabelProps={{ shrink: true }}
                    className="addform"
                    style={{ width: "45%" }}
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(e) => setDOB(e.target.value)}
                    value={DOB}
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Contact"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setcontact(e.target.value)}
                    value={contact}
                  />
                  <TextField
                    type="email"
                    className="addform"
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setemail(e.target.value)}
                    value={email}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="National Insurance"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setNationalInsurance(e.target.value)}
                    value={nationalInsurance}
                  />

                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Address 1"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setaddress1(e.target.value)}
                    value={address1}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Address 2"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setaddress2(e.target.value)}
                    value={address2}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Town/County"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => settown(e.target.value)}
                    value={town}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Post Code"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setpostCode(e.target.value)}
                    value={postCode}
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Qty of Children"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setchild(e.target.value)}
                    value={child}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Children’s Location"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setchildloc(e.target.value)}
                    value={childloc}
                  />
                  {/* <TextField type="text" className='addform' id="outlined-basic" label="Post Code" variant="outlined" style={{ width: "45%", visibility: "hidden" }} /> */}

                  {/* JOE CONVERT EMERGENCY TO THIS */}

                  <TextField
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Name"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setnextOfKinName(e.target.value)}
                    value={nextOfKinName}
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Number"
                    variant="outlined"
                    style={{ width: "45%" }}
                    onChange={(e) => setnextOfKinNumber(e.target.value)}
                    value={nextOfKinNumber}
                  />
                  {/* <TextField type="text" className='addform' id="outlined-basic" label="Next of Kin Relationship" variant="outlined" style={{ width: "45%" }} onChange={(e) => setnextOfKineRelationship(e.target.value)} value={nextOfKineRelationship} /> */}
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Next of kin Relationship"
                    variant="outlined"
                    style={{ width: "45%", visibility: "hidden" }}
                  />

                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      marginTop: "30px",
                      width: "49%",
                      color: "#F21D2F",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleComplete}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "49%",
                      height: "50px",
                      marginTop: "30px",
                      backgroundColor: "#F21D2F",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                  </Button>

                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Next of kin Relationship"
                    variant="outlined"
                    style={{
                      width: "45%",
                      visibility: "hidden",
                      paddingBottom: "30px",
                    }}
                  />
                </div>
              ) : activeStep == 1 ? (
                <>
                  <div className="LoginPageALT">
                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Buddy Referral{" "}
                      </InputLabel>
                      <Select
                        value={buddy}
                        onChange={(e) => setbuddy(e.target.value)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <hr className="solid" />
                  <div className="LoginPageALT">
                    {inputList.map((x, i) => {
                      return (
                        <div style={{ width: "100%" }}>
                          <FormControl style={{ width: "45%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Status Type
                            </InputLabel>
                            <Select
                              value={inputList[i].status}
                              name="status"
                              onChange={(e) => handleInputChange(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                            >
                              {dropDownData
                                ? dropDownData.housingStatusType.map((val) => (
                                    <MenuItem value={val}>{val}</MenuItem>
                                  ))
                                : null}
                            </Select>
                          </FormControl>

                          <TextField
                            onChange={(e) => handleInputChange(e, i)}
                            value={inputList[i].date}
                            name="date"
                            type="date"
                            label="Date"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "45%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          {inputList.length !== 1 && (
                            <Button
                              onClick={() => handleRemoveClick(i)}
                              className="addform"
                              variant="contained"
                              style={{
                                width: "5%",
                                backgroundColor: "#FF6A74",
                                marginLeft: "10px",
                                height: "50px",
                                color: "white ",
                                borderColor: "red",
                              }}
                            >
                              <DeleteIcon sx={{ color: "white" }} />
                            </Button>
                          )}

                          <div className="btn-box">
                            {inputList.length - 1 === i && (
                              <Button
                                onClick={handleAddClick}
                                className="addform"
                                variant="outlined"
                                style={{
                                  width: "100%",
                                  height: "50px",
                                  marginTop: "30px",
                                  color: "#F21D2F",
                                  borderColor: "#F21D2F",
                                }}
                              >
                                + Add New
                              </Button>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "49%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "49%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 2 ? (
                <>
                  <div style={{ marginTop: "10px" }}>
                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      size="small"
                      label={Agencies.AdultCare.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.AdultCare.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.AdultCare.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            AdultCare: {
                              ...Agencies.AdultCare,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      className="addform"
                      size="small"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.AdultCare.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          AdultCare: {
                            ...Agencies.AdultCare,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      size="small"
                      label={Agencies.MentalHealth.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.MentalHealth.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.MentalHealth.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            MentalHealth: {
                              ...Agencies.MentalHealth,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.MentalHealth.Contactname}
                      size="small"
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          MentalHealth: {
                            ...Agencies.MentalHealth,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      size="small"
                      label={Agencies.CGL.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.CGL.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.CGL.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            CGL: {
                              ...Agencies.CGL,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      className="addform"
                      size="small"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.CGL.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          CGL: {
                            ...Agencies.CGL,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      size="small"
                      label={Agencies.Housing.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Housing.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.Housing.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            Housing: {
                              ...Agencies.Housing,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Housing.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Housing: {
                            ...Agencies.Housing,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.SocialServices.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.SocialServices.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.SocialServices.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            SocialServices: {
                              ...Agencies.SocialServices,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.SocialServices.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          SocialServices: {
                            ...Agencies.SocialServices,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.Probation.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Probation.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.Probation.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            Probation: {
                              ...Agencies.Probation,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Probation.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Probation: {
                            ...Agencies.Probation,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.FoodBank.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.FoodBank.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.FoodBank.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            FoodBank: {
                              ...Agencies.FoodBank,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.FoodBank.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          FoodBank: {
                            ...Agencies.FoodBank,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />
                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.GP.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.GP.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.GP.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            GP: {
                              ...Agencies.GP,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.GP.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          GP: {
                            ...Agencies.GP,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.Blank1.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Blank1.Name}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Blank1: {
                            ...Agencies.Blank1,
                            Name: e.target.value,
                          },
                        })
                      }
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.Blank1.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            Blank1: {
                              ...Agencies.Blank1,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Blank1.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Blank1: {
                            ...Agencies.Blank1,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={Agencies.Blank2.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Blank2.Name}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Blank2: {
                            ...Agencies.Blank2,
                            Name: e.target.value,
                          },
                        })
                      }
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={Agencies.Blank2.Consent}
                        size="small"
                        onChange={(e) =>
                          setAgencies({
                            ...Agencies,
                            Blank2: {
                              ...Agencies.Blank2,
                              Consent: e.target.value,
                            },
                          })
                        }
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={Agencies.Blank2.Contactname}
                      onChange={(e) =>
                        setAgencies({
                          ...Agencies,
                          Blank2: {
                            ...Agencies.Blank2,
                            Contactname: e.target.value,
                          },
                        })
                      }
                    />
                  </div>

                  <div className="LoginPage">
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "49%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "49%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 3 ? (
                <>
                  <div
                    style={{ display: "flex", marginTop: "50px", gap: "10px" }}
                  >
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      className="addform"
                      id="outlined-basic"
                      label="Start Date"
                      variant="outlined"
                      style={{ width: "45%", flex: 2 }}
                      onChange={(e) => setstartDate(e.target.value)}
                      value={startDate}
                    />
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      className="addform"
                      id="outlined-basic"
                      label="Actual End Date"
                      variant="outlined"
                      style={{ width: "45%", flex: 2 }}
                      onChange={(e) => setactualEndDate(e.target.value)}
                      value={actualEndDate}
                    />
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      className="addform"
                      id="outlined-basic"
                      label="Expected End Date"
                      variant="outlined"
                      style={{ width: "45%", flex: 2, visibility: "hidden" }}
                      onChange={(e) => setexpectedDate(e.target.value)}
                      value={expectedDate}
                    />
                  </div>

                  <div style={{ marginTop: "20px" }} id="LIFESTYLE">
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Alcohol Misuse/Addiction
                      </InputLabel>
                      <Select
                        value={LifeStyle.Alchohol}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Alchohol: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Alcohol Misuse/Addiction"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Offending Behaviour
                      </InputLabel>
                      <Select
                        value={LifeStyle.Behaviour}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Behaviour: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Depression
                      </InputLabel>
                      <Select
                        value={LifeStyle.Depression}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Depression: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Drug Missuse/Addiction
                      </InputLabel>
                      <Select
                        value={LifeStyle.Drug}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Drug: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}>Empty</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Eating Disorder
                      </InputLabel>
                      <Select
                        value={LifeStyle.Eating}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Eating: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Mental Health
                      </InputLabel>
                      <Select
                        value={LifeStyle.Mental}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Mental: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Debt Problems
                      </InputLabel>
                      <Select
                        value={LifeStyle.Debt}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Debt: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Self Harm
                      </InputLabel>
                      <Select
                        value={LifeStyle.Self}
                        onChange={(e) =>
                          setLifeStyle({ ...LifeStyle, Self: e.target.value })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Physical Health
                      </InputLabel>
                      <Select
                        value={LifeStyle.Physical}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Physical: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Unemployment
                      </InputLabel>
                      <Select
                        value={LifeStyle.Unemployment}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Unemployment: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Low Self Esteem/Confidence
                      </InputLabel>
                      <Select
                        value={LifeStyle.Confidence}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Confidence: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Violent Behaviour
                      </InputLabel>
                      <Select
                        value={LifeStyle.Violent}
                        onChange={(e) =>
                          setLifeStyle({
                            ...LifeStyle,
                            Violent: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div className="LoginPage">
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "49%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "49%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 4 ? (
                <>
                  <div style={{ marginTop: "30px" }}>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Alcohol
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Alchohol}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Alchohol: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Amphetamines
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Amphetamines}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Amphetamines: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Cannabis
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Cannabis}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Cannabis: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Cocaine
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Cocaine}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Cocaine: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Crack
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Crack}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Crack: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Ecstasy
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Ecstasy}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Ecstasy: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Heroin
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Heroine}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Heroine: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Ketamine
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Ketamine}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Ketamine: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Pregabline
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Pregabline}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Pregabline: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Smoker
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Cigrates}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Cigrates: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Spice
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Spice}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Spice: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Vaping
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Vaping}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Vaping: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Zopiclone
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Zopiclone}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Zopiclone: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Other
                      </InputLabel>
                      <Select
                        value={RehabDrugs.Other}
                        onChange={(e) =>
                          setRehabDrugs({
                            ...RehabDrugs,
                            Other: e.target.value,
                          })
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        width: "32%",
                        margin: "5px",
                        visibility: "hidden",
                      }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Ecstasy
                      </InputLabel>
                      <Select
                        // value={inputList1[i].location}
                        // name="location"
                        // onChange={e => handleInputChange1(e, i)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="LoginPage">
                    {inputList1.map((x, i) => {
                      return (
                        <div style={{ width: "100%" }}>
                          <FormControl style={{ width: "18%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Status
                            </InputLabel>
                            <Select
                              value={inputList1[i].status}
                              name="status"
                              onChange={(e) => handleInputChange1(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                            >
                              <MenuItem value={"enter"}>Entered Rehab</MenuItem>
                              <MenuItem value={"left"}>Left Rehab</MenuItem>
                              <MenuItem value={"null"}></MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{ width: "12%", marginLeft: "10px" }}
                          >
                            <InputLabel id="demo-simple-select-label">
                              Location
                            </InputLabel>
                            <Select
                              value={inputList1[i].location}
                              name="location"
                              onChange={(e) => handleInputChange1(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                            >
                              {dropDownData
                                ? dropDownData.rehabLocation.map((val) => (
                                    <MenuItem value={val}>{val}</MenuItem>
                                  ))
                                : null}
                            </Select>
                          </FormControl>

                          <TextField
                            onChange={(e) => handleInputChange1(e, i)}
                            value={inputList1[i].startDate}
                            name="startDate"
                            type="date"
                            label="Start Date"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "18%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          <TextField
                            onChange={(e) => handleInputChange1(e, i)}
                            value={inputList1[i].endDate}
                            name="endDate"
                            type="date"
                            label="End Date"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "18%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          <TextField
                            onChange={(e) => handleInputChange1(e, i)}
                            value={inputList1[i].value}
                            name="value"
                            type="number"
                            label="Expense £"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "10%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />

                          <TextField
                            onChange={(e) => handleInputChange1(e, i)}
                            value={inputList1[i].comment}
                            name="comment"
                            type="text"
                            label="Expense Comments"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "18%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          {inputList1.length !== 1 && (
                            <Button
                              onClick={() => handleRemoveClick1(i)}
                              className="addform"
                              variant="contained"
                              style={{
                                width: "5%",
                                backgroundColor: "#FF6A74",
                                marginLeft: "10px",
                                height: "50px",
                                color: "white ",
                                borderColor: "red",
                              }}
                            >
                              <DeleteIcon sx={{ color: "white" }} />
                            </Button>
                          )}

                          <div className="btn-box">
                            {inputList.length - 1 === i && (
                              <Button
                                onClick={handleAddClick1}
                                className="addform"
                                variant="outlined"
                                style={{
                                  width: "100%",
                                  height: "50px",
                                  marginTop: "30px",
                                  color: "#F21D2F",
                                  borderColor: "#F21D2F",
                                }}
                              >
                                + Add New
                              </Button>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "49%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "49%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 5 ? (
                <>
                  <div className="LoginPageALT">
                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Prison{" "}
                      </InputLabel>
                      <Select
                        value={prison}
                        onChange={(e) => setprison(e.target.value)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="number"
                      className="addform"
                      id="outlined-basic"
                      label="How many times"
                      variant="outlined"
                      style={{ width: "45%" }}
                      onChange={(e) => sethowMany(e.target.value)}
                      value={howMany}
                    />

                    <TextField
                      type="number"
                      className="addform"
                      id="outlined-basic"
                      label="Total Months Served"
                      variant="outlined"
                      style={{ width: "45%" }}
                      onChange={(e) => settotlaMonthsServed(e.target.value)}
                      value={totlaMonthsServed}
                    />

                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Probation{" "}
                      </InputLabel>
                      <Select
                        value={probation}
                        onChange={(e) => setProbation(e.target.value)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      label="Probation Officer"
                      variant="outlined"
                      style={{ width: "45%" }}
                      onChange={(e) => setProbationOfficer(e.target.value)}
                      value={probationOfficer}
                    />

                    {/* <FormControl style={{ width: "45%" }}>
                              <InputLabel id="demo-simple-select-label">Sex Offender </InputLabel>
                              <Select
                                value={sexOffender}
                                onChange={(e) => setSexOffender(e.target.value)}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Location"
                              >
                                <MenuItem value={"yes"}>Yes</MenuItem>
                                <MenuItem value={"no"}>No</MenuItem>
                              </Select>
                            </FormControl> */}

                    <TextField
                      type="number"
                      className="addform"
                      id="outlined-basic"
                      label="Number of Offences"
                      variant="outlined"
                      style={{ width: "45%" }}
                      onChange={(e) => setNumberOfOffences(e.target.value)}
                      value={numberOfOffences}
                    />

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      label="Next of Kin Relationship"
                      variant="outlined"
                      style={{ width: "45%", visibility: "hidden" }}
                      onChange={(e) =>
                        setnextOfKineRelationship(e.target.value)
                      }
                      value={nextOfKineRelationship}
                    />
                  </div>
                  <hr className="solid" />
                  <div className="LoginPageALT">
                    {inputList2.map((x, i) => {
                      return (
                        <div style={{ width: "100%" }}>
                          <FormControl style={{ width: "28%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Conviction Type
                            </InputLabel>
                            <Select
                              value={inputList2[i].type}
                              name="type"
                              onChange={(e) => handleInputChange2(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                            >
                              {dropDownData
                                ? dropDownData.OffendingHistoryConvictionType.map(
                                    (val) => (
                                      <MenuItem value={val}>{val}</MenuItem>
                                    )
                                  )
                                : null}
                            </Select>
                          </FormControl>

                          <TextField
                            onChange={(e) => handleInputChange2(e, i)}
                            value={inputList2[i].details}
                            name="details"
                            type="text"
                            label="Details"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "28%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          <TextField
                            onChange={(e) => handleInputChange2(e, i)}
                            value={inputList2[i].date}
                            name="date"
                            type="date"
                            label="Date of Conviction"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "28%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          {inputList2.length !== 1 && (
                            <Button
                              onClick={() => handleRemoveClick2(i)}
                              className="addform"
                              variant="contained"
                              style={{
                                width: "5%",
                                backgroundColor: "#FF6A74",
                                marginLeft: "10px",
                                height: "50px",
                                color: "white ",
                                borderColor: "red",
                              }}
                            >
                              <DeleteIcon sx={{ color: "white" }} />
                            </Button>
                          )}

                          <div className="btn-box">
                            {inputList2.length - 1 === i && (
                              <Button
                                onClick={handleAddClick2}
                                className="addform"
                                variant="outlined"
                                style={{
                                  width: "100%",
                                  height: "50px",
                                  marginTop: "30px",
                                  color: "#F21D2F",
                                  borderColor: "#F21D2F",
                                }}
                              >
                                + Add New
                              </Button>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "49%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "49%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {"Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 6 ? (
                <div className="LoginPage">
                  <TextField
                    type="date"
                    label="Date"
                    InputLabelProps={{ shrink: true }}
                    className="addform"
                    style={{ width: "45%" }}
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(e) => setconcDate(e.target.value)}
                    value={concDate}
                  />
                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-label">Type</InputLabel>
                    <Select
                      onChange={(e) => setconcType(e.target.value)}
                      value={concType}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Type"
                    >
                      {dropDownData
                        ? dropDownData.CorrespondenceType.map((val) => (
                            <MenuItem value={val}>{val}</MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                  {/* <TextField type="text" label="Logged By" InputLabelProps={{ shrink: true, }} className='addform' style={{ width: "100%" }} id="outlined-basic" variant="outlined" onChange={(e) => setconcLog(e.target.value)} value={concLog} /> */}
                  <FormControl style={{ width: "100%" }}>
                    <InputLabel id="demo-simple-select-label">
                      Logged By{" "}
                    </InputLabel>
                    <Select
                      value={concLog}
                      onChange={(e) => setconcLog(e.target.value)}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Location"
                    >
                      {rows.map((v) => {
                        return (
                          <MenuItem value={v.firstName + " " + v.surName}>
                            {v.firstName + " " + v.surName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    onChange={(e) => setconcComment(e.target.value)}
                    value={concComment}
                    className="addform"
                    style={{ width: "100%" }}
                    // id={ `tt_description_text outlined-multiline-static`}
                    label="Add a comment "
                    multiline
                    rows={5}
                    // onBlur={ (f)=>(this.textOnBlur({id:answeringPainSpot.spotId, value:f.target.value, doc_name:answeringPainSpot.doc_name})) }
                  />

                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "49%",
                      color: "#F21D2F",
                      borderColor: "#F21D2F",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleCompleteSPC}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "49%",
                      backgroundColor: "#F21D2F",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                  </Button>
                </div>
              ) : (
                <div className="LoginPage">
                  <ul>
                    {url.map((item) => {
                      return <li>{item.name}</li>;
                    })}
                  </ul>

                  <DropzoneAreaBase
                    filesLimit="3"
                    maxFileSize={500000000000000}
                    onDrop={async (accept) => {
                      const file = accept[0];
                      console.log(file.path);

                      const blob = await fetch(URL.createObjectURL(file)).then(
                        (r) => r.blob()
                      );
                      const storageRef = ref(
                        storage,
                        `files/${file.lastModified}`
                      );

                      await uploadBytes(storageRef, blob).then((snapshot) => {
                        getDownloadURL(
                          ref(storage, `files/${file.lastModified}`)
                        )
                          .then((u) => {
                            let obj = {
                              path: file.lastModified,
                              name: file.path,
                              url: u,
                            };

                            seturl((oldArray) => [...oldArray, obj]);
                            console.log(url);
                          })
                          .catch((error) => {
                            alert("try again later");
                          });
                      });
                    }}
                  />

                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "49%",
                      color: "#F21D2F",
                      borderColor: "#F21D2F",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={pushData}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "49%",
                      backgroundColor: "#F21D2F",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Finish" : "Next"}
                  </Button>
                </div>
              )}

              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          )}
        </div>
      </Box>
    </Box>
  );
}
